import { useEffect, useState } from "react";
import { Box, Text, Badge } from "@chakra-ui/react";
import { supabase } from "../utils/supabaseClient";

export default function DebugOverlay({ businessId }) {
  const [queueCount, setQueueCount] = useState(null);
  const [rpcStatus, setRpcStatus] = useState("pending");

  useEffect(() => {
    const fetchQueue = async () => {
      if (!businessId) return;

      try {
        const { data, error } = await supabase
          .from("dispatch_queue")
          .select("id", { count: "exact", head: true })
          .eq("business_id", businessId);

        if (error) throw error;
        setQueueCount(data?.length ?? 0);
        setRpcStatus("healthy");
      } catch (err) {
        setRpcStatus("error");
      }
    };

    fetchQueue();
  }, [businessId]);

  return (
    <Box
      position="fixed"
      bottom={4}
      right={4}
      bg="gray.800"
      color="white"
      p={4}
      borderRadius="md"
      boxShadow="lg"
      zIndex={999}
    >
      <Text fontSize="sm">🧠 Debug Overlay</Text>
      <Text fontSize="xs">Business ID: {businessId || "null"}</Text>
      <Text fontSize="xs">Dispatch Queue: {queueCount ?? "..."}</Text>
      <Text fontSize="xs">
        RPC Status:{" "}
        <Badge colorScheme={rpcStatus === "healthy" ? "green" : "red"}>
          {rpcStatus}
        </Badge>
      </Text>
    </Box>
  );
}
